export function Spinner({ label = "Loading" }: { label?: string }) {
  return <span className="as-spinner" role="status" aria-label={label} />;
}
